import { DomainMessagesTypes } from 'shared/domain/messages/message';
import * as dbIssueWorkflows from 'serviceWorker/db/issueWorkflows/issueWorkflows';
import * as dbIssueWorkflowsService from 'serviceWorker/db/issueWorkflows/issueWorkflowsService';
import { makeLoadedEventPublisher, readCollectionPayload } from './publishers';
import { workflowContract } from 'shared/domain/workflow/workflowContract';

export const broadcastAllIssueWorkflows = makeLoadedEventPublisher(
  workflowContract,
  DomainMessagesTypes.allIssueWorkflows,
  () => readCollectionPayload(dbIssueWorkflowsService, dbIssueWorkflows.get)
);
